
<div
  :class="
    classes(
      n(),
      {
        [n('--disabled')]: mergedDisabled,
        [n('--focused')]: isFocused,
        [n('--in-form-item')]: inFormItem,
      }
    )
  "
>
  <div :class="n('wrapper')">
    <div :class="n('row')">
      <!-- 输入框容器 -->
      <div :class="n('input-wrapper')">
        <!-- 前缀 -->
        <div
          v-if="$slots.prefix"
          :class="n('prefix')"
        >
          <slot name="prefix" />
        </div>

        <!-- 原生input -->
        <input
          ref="inputRef"
          :class="n('native')"
          :type="type"
          :value="innerValue"
          :placeholder="placeholder"
          :placeholder-class="n('placeholder')"
          :disabled="mergedDisabled"
          v-bind="readonly ? { readonly: true } : {}"
          :maxlength="maxlength"
          :name="name"
          :autofocus="autofocus"
          :inputmode="inputMode"
          :adjust-position="adjustPosition"
          :style="{ textAlign: inputAlign }"
          @input="handleInput"
          @focus="handleFocus"
          @blur="handleBlur"
          @change="handleChange"
          @keydown="handleKeydown"
          @keyup="handleKeyup"
        >

        <!-- 后缀 -->
        <div
          v-if="$slots.suffix"
          :class="n('suffix')"
        >
          <slot name="suffix" />
        </div>
      </div>

      <!-- 操作区 -->
      <div
        v-if="$slots.action"
        :class="n('action')"
        @click="handleActionClick"
      >
        <slot name="action" />
      </div>
    </div>
  </div>
</div>
